import * as RadixProgress from "@radix-ui/react-progress";

/**
 * Progress bar component for onboarding flow showing user's progression through steps.
 * Handles zero-based currentIndex by converting to one-based calculation for proper visual progress.
 * For follow-up steps, the parent component should pass the parent step's index to maintain consistent progress.
 */
const OnboardingProgressBar = ({
  currentIndex,
  totalSteps,
}: {
  currentIndex: number;
  totalSteps: number;
}) => {
  // Convert zero-based index to one-based for proper progress calculation
  // Add 1 to currentIndex so first step (index 0) shows progress, and final step shows 100%
  const progressPercent = Math.floor(((currentIndex + 1) / totalSteps) * 100);

  return (
    <RadixProgress.Root
      className="relative h-1 w-full overflow-hidden rounded-full bg-zinc-200"
      value={progressPercent}
      style={{ transform: "translateZ(0)" }}
    >
      <RadixProgress.Indicator
        className="h-full rounded-full bg-spring transition-all duration-300 ease-in-out"
        style={{
          width: `${progressPercent}%`,
        }}
      />
    </RadixProgress.Root>
  );
};

export default OnboardingProgressBar;
